export default "__VITE_ASSET__B5il3Q4q__"